<template>
    <div class="news-list px-lg-0 px-3">


        <div class="row" v-for="(item) in news" :key="item.id">

            <div class="col-12 col-lg-2">
                <a v-if="item.catImagesCount > 0" :href="newsLink(item)" target="_blank">
                    <img class="news-ann-img" :src="`https://www.poliglotiki.ru/a/160/144/${item.catImages[0].id}`"
                         alt="">
                </a>
                <a v-else :href="newsLink(item)" target="_blank">
                    <img class="news-ann-img" src="https://www.poliglotiki.ru/a/160/144/1"
                         alt="">
                </a>
            </div>
            <div class="col-12 col-lg-8">
                <div class="row">
                    <div class="col-12 news-list-date">{{ item.create_time | formatDate }}</div>
                    <div class="col-12 news-list-name"><a :href="newsLink(item)">{{item.name}}</a>
                    </div>
                    <div class="col-12 news-list-newscategoryname">
                        <a :href="newsCategoryLink(item)" :title="`Читать все ${item.newsCategory.name}`"
                           target="_blank">{{item.newsCategory.name}}</a>
                    </div>
                    <div class="col-12 news-list-anons">
                        {{ newsTizer(item) }}... <a :href="newsLink(item)" target="_blank">Подробнее →</a>
                    </div>

                    <div class="col-2 new-separator">

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import NewsApi from "../data/NewsApi";
    import moment from 'moment';

    export default {
        name: "News",
        props: ['newsCategoryId', 'perPage', 'page'],
        components: {},
        data() {
            return {
                news: [],
                loading: false,
                error: false,
            }
        },

        mounted() {
            this.loading = true
            NewsApi.fetchNews(this.newsCategoryId, this.perPage, this.page)
                .then(response => {
                    this.news = response
                })
                .catch(error => {
                    let data = error.response.data
                    this.error = this.pretty(data)
                    this.loading = false
                })
        },

        filters: {
            formatDate: function (value) {
                return moment.unix(value).format('DD.MM.YYYY')
            }
        },

        methods: {
            newsLink(news) {
                return 'https://www.poliglotiki.ru/' + news.newsCategory.url + '/' + news.slug
            },

            newsCategoryLink(news) {
                return 'https://www.poliglotiki.ru/' + news.newsCategory.url
            },

            stripHtml(html) {
                // Create a new div element
                var temporalDivElement = document.createElement("div");
                // Set the HTML content with the providen
                temporalDivElement.innerHTML = html;
                // Retrieve the text property of the element (cross-browser support)
                return temporalDivElement.textContent || temporalDivElement.innerText || "";
            },

            newsTizer(news) {
                let text = '';
                if (news.html) text = this.stripHtml(news.text)
                else text = news.text
                return text.substring(0, 190)
            },

            pretty(value) {
                if (value.message) {
                    return value.message
                }
                return JSON.stringify(value, null, 2)
            },
        }
    }
</script>

<style scoped>
    .news-list-date {
        font-size: 14px;
        color: #4f4d5c;
    }

    .news-list-name a {
        font-family: Manrope Bold;
        color: #231c37;
        margin-top: -5px;
    }

    .news-list-newscategoryname a {
        color: #8b8496;
        text-decoration: underline;
        font-size: 14px;
        margin-top: -5px;
    }

    .news-list-anons {
        color: #4f4d5c;
        font-size: 16px;
        line-height: 18px;
        margin-top: 20px;
    }

    .news-list-anons a {
        font-size: 14px;
        color: #8b8496;
        text-decoration: underline;
    }

    .news-list-link-to {
        margin-top: 10px;
        font-size: 14px;
        font-family: Manrope Bold;
    }

    .news-list-link-to a {
        font-size: 14px;
        color: #8b8496;
        text-decoration: underline;
        font-family: Manrope Light;
    }

    .new-separator {
        border-top: 1px solid #d7e1e5;
        margin-left: 15px;
        margin-top: 25px;
        margin-bottom: 50px;
    }

    .news-ann-img {
        max-width: 100%;
    }
</style>
